'use strict';
angular.module('TurneroApp').component('coFrameExterno', {

    controller: ['centrosAtencionService', '$stateParams', 'agendaService', 'tramiteService', 'utilsService'
    , '$scope', 'TurneroAppConstant', 'turnosService', 'loginService', '$rootScope', '$window', '$location', 'loginErrorService',
        function (centrosAtencionService, $stateParams, agendaService, tramiteService, utilsService
            , $scope, TurneroAppConstant, turnosService, loginService, $rootScope, $window, $location, loginErrorService) {
		var ctrl = this;
		ctrl.Turno = null;
		ctrl.Modalidades = TurneroAppConstant.Modalidades;
		ctrl.$onInit = function () {
			ctrl.limpiarMemoria();

            var sesionId = $stateParams.sesionid || $stateParams.sessionId || $stateParams.sessionid;
            if (sesionId)
            {
                ctrl.setSesionId(sesionId);
            }
            else
            {
                ctrl.configure();
            }
		};

        ctrl.setSesionId = function (sesionId) {
			loginService.setSesionId({
				'sesionid': sesionId
			}).$promise.then(function (result) {
				if (result && result.Url) {
					return loginService.Post_Usuario_VeDi().$promise.then(function (data)
					{
                        var parametros = angular.copy($location.search());
                        delete parametros.sesionid;
                        delete parametros.sessionId;
                        delete parametros.sessionid;
                        $window.location.href = result.Url + construirQueryString(parametros);
					});
				}else{
					mostrarError();
				}
			}).catch(mostrarError);
		}

        function mostrarError(error) {
            ctrl.limpiarMemoria();
            ctrl.loadingPersona = false;
            ctrl.errorInicioSesion = loginErrorService.mostrar(error);
        }

        function construirQueryString(parametros) {
            var partes = [];
            angular.forEach(parametros, function (valor, nombre) {
                if (valor !== undefined && valor !== null && valor !== '') {
                    partes.push(encodeURIComponent(nombre) + '=' + encodeURIComponent(valor));
                }
            });
            return partes.length ? '?' + partes.join('&') : '';
        }

        ctrl.configure = function (){
            if ($stateParams.tramitePortal && $stateParams.modalidad) {
                ctrl.id_Modalidad = $stateParams.modalidad.toUpperCase() == TurneroAppConstant.Modalidades_IFrame.Online ? ctrl.Modalidades.OnLine : $stateParams.modalidad.toUpperCase() == TurneroAppConstant.Modalidades_IFrame.Presencial ? ctrl.Modalidades.Presencial : null;
                ctrl.Id_Tramite_Relevado = $stateParams.tramitePortal;
                ctrl.obtenerTramite(ctrl.Id_Tramite_Relevado);
                ctrl.MostrarCalendario = true;
                if ($stateParams.idCentroAtencion) {
                    ctrl.Id_Centro_Atencion = $stateParams.idCentroAtencion;
                }
                if (!ctrl.id_Modalidad) {
                    ctrl.MostrarCalendario = false;
                }
                if ($stateParams.n_ciudadano || $stateParams.idPersona) {
                    if ($stateParams.n_ciudadano) {
                        var filtro = {
                            Id_Tipo_Doc: 'CUIL',
                            Nro_Documento: $stateParams.n_ciudadano
                        }
                    } else {
                        var filtro = {
                            Id_Tipo_Doc: 'DNI',
                            Nro_Documento: $stateParams.idPersona.substring(2, 10),
                            Id_Numero: $stateParams.idPersona.substring(13, 14),
                            Id_Sexo: $stateParams.idPersona.substring(0, 2),
                            Pai_Cod_Pais: $stateParams.idPersona.substring(10, 13)
                        }
                    }

                    //utilsService.swalTitle('Buscando ciudadano', 'info');
                    ctrl.loadingPersona = true;
                    turnosService.Get_Persona(filtro).$promise.then(function (resultado) {
                        ctrl.loadingPersona = false;
                        if (resultado.Data.length == 1) {
                            ctrl.Persona = resultado.Data[0];
                        } else if (resultado.Data.length > 1) {
                            ctrl.Persona = null;
                        } else {
                            ctrl.Persona = null;
                        }
                        swal.close();

                    }).catch(function (error) {
                        utilsService.errores(error);
                    })
                }

            } else if ($stateParams.tramitePortal && !$stateParams.modalidad && !$stateParams.idCodigo) {
                var tramitePortal = $stateParams.tramitePortal ? ('turnosPortal?tramitePortal=' + $stateParams.tramitePortal.toString()) : null;
                var centroPortal = tramitePortal && $stateParams.idCentroAtencion ? '&idCentroAtencion=' + $stateParams.idCentroAtencion.toString() : null;
                var idAgendaPortal = tramitePortal && $stateParams.idAgenda ? '&idAgenda=' + $stateParams.idAgenda.toString() : null;
                var portalURL = tramitePortal + (centroPortal ? centroPortal : '') + (idAgendaPortal ? idAgendaPortal : '');
                window.location = $rootScope.urlHostServer + (portalURL);
            } else if ($stateParams.idCentroAtencion && !$stateParams.modalidad && !$stateParams.idCodigo) {
                let centroPortal = $stateParams.idCentroAtencion ? 'turnosPortal?idCentroAtencion=' + $stateParams.idCentroAtencion.toString() : null;
                window.location = $rootScope.urlHostServer + (centroPortal);
            }
        }

		ctrl.limpiarMemoria = function () {
			ctrl.MostrarCalendario = false;
			ctrl.MostrarConfirmacion = false;
		};

		ctrl.obtenerTramite = function (Id_Tramite) {
			tramiteService.Get_Tramite({ 'Id_Tramite_Relevado': Id_Tramite }).$promise.then(function (result) {
				ctrl.tramite_Seleccionado = result.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}

		ctrl.regresarCalendario = function () {
			ctrl.MostrarConfirmacion = false;
			ctrl.MostrarCalendario = true;
			ctrl.Turnos = null;
		}

		ctrl.confirmarTurno = function (dataTurno) {
			if (dataTurno != null) {
				ctrl.centroSeleccionado.agenda_Seleccionada = ctrl.ctrlHijo.agendaSeleccionada;
				ctrl.Turno = {
					Datos: dataTurno,
					Centro: ctrl.centroSeleccionado,
					Tramite: {
						Id_Tramite_Relevado: ctrl.tramite_Seleccionado.id_tramite,
						N_Tramite: ctrl.tramite_Seleccionado.n_tramite
					},
                    Codigo: null
				};
				ctrl.MostrarCalendario = false;
				ctrl.MostrarConfirmacion = true;
				$scope.$apply()
			}
		}

	}],
	template: require('./headerExterno.html')
});



// WEBPACK FOOTER //
// ./app/shared/calendarioExterno/headerExternoComponent.js